import { useAtom } from 'jotai';
import { annotationVisibilityCallbackAtom } from '../atoms';
export const useAnnotationVisibilityHandler = () => {
  const [annotationVisibilityCallback, setAnnotationVisibilityCallback] = useAtom(annotationVisibilityCallbackAtom);
  return {
    ...annotationVisibilityCallback,
    setAnnotationVisibilityCallback
  };
};